import { ReCaptchaVersion } from '@pressreader/utils';

export enum AuthStatus {
    Success,
    InvalidUserNameOrPassword,
    ExceedMaxSimultaneousSessionsPerUser,
    UnknownError,
    ExceedMaxIncorrectPasswordAttempts,
    CaptchaFailed,
    UserIsAlreadyRegistered,
    InvalidEmailAddress,
    MaxNumberOfEmailsReached,
    UserIsPendingVerification,
}

export interface NewUser {
    emailAddress: string;
    password: string;
    firstName: string;
    lastName: string;
    enablePromotional: boolean;
    enableService: boolean;

    libraryUser?: unknown;
    reCaptchaVersion?: ReCaptchaVersion;
    reCaptchaToken?: string;
    returnUrl?: string;
}

export interface SignInResultDto {
    SponsorId?: number;
    Token: string;
    Status: AuthStatus;
    UserKey: string;
}

export enum SendVerificationEmailResult {
    PendingDelivery,
    MaxNumberOfEmailsReached,
    Failure,
}

export enum RegistrationStatus {
    Unregistered,
    Registered,
}
